module.exports = __webpack_public_path__ + "static/media/p208b1.2ee3c509.jpg";